module.exports = __webpack_public_path__ + "static/media/pp-8.2a726812.jpg";